import { DISTRIBUTION_CHANNEL } from "@/consts/survey";
import { i18n } from "@/boot/i18n";
import { getVariablesHSM } from "@/utils/getHsVariables";

export const validateMessages = (distribution) => {
  const response = { field: "message", message: "", meta: { tab: "info" } };

  //Validate invite channel template
  if (distribution.distribution_channel === DISTRIBUTION_CHANNEL.EMAIL) {
    if (!distribution.template_email_invite_hash) {
      response.message = i18n.t("distribution.messages.invite_message_error");
      return response;
    }
  }

  if (distribution.distribution_channel === DISTRIBUTION_CHANNEL.LINKSMS) {
    if (!distribution.template_smslink_invite_hash) {
      response.message = i18n.t("distribution.messages.invite_message_error");
      return response;
    }
  }

  //Validate survey complete template
  if (!distribution.template_survey_thanks_hash) {
    response.message = i18n.t("distribution.messages.ending_message_error");
    return response;
  }

  //Validate survey expired template
  if (!distribution.template_survey_expired_hash) {
    response.message = i18n.t("distribution.messages.expired_message_error");
    return response;
  }

  //Validate reminder template
  if (distribution.distribution_channel === DISTRIBUTION_CHANNEL.EMAIL && distribution.reminder_at) {
    if (!distribution.template_email_reminder_hash) {
      response.message = i18n.t("distribution.messages.reminder_message_error");
      return response;
    }
  }
  if (distribution.distribution_channel === DISTRIBUTION_CHANNEL.LINKSMS && distribution.reminder_at) {
    if (!distribution.template_smslink_reminder_hash) {
      response.message = i18n.t("distribution.messages.reminder_message_error");
      return response;
    }
  }

  //Validate whatsapp template
  if (distribution.distribution_channel === DISTRIBUTION_CHANNEL.WHATSAPP) {
    if (!distribution.whatsapp_template.name) {
      response.message = i18n.t("distribution.messages.hsm_template_empty");
      return response;
    }
    
    if (distribution.reminder_at > 0 && !distribution.whatsapp_reminder_template.name) {
      response.message = i18n.t("distribution.messages.hsm_reminder_template_empty");
      return response;
    }

    const variables = getVariablesHSM(distribution.whatsapp_template.body);
    if (!distribution.whatsapp_template.body || distribution.whatsapp_template.variables.length !== variables.length) {
      response.message = i18n.t("distribution.messages.hsm_variables_empty");
      return response;
    }

    const reminder_variables = getVariablesHSM(distribution.whatsapp_reminder_template.body);
    if (distribution.reminder_at > 0  && (!distribution.whatsapp_reminder_template.body || distribution.whatsapp_reminder_template.variables.length !== reminder_variables.length)) {
      response.message = i18n.t("distribution.messages.hsm_reminder_variables_empty");
      return response;
    }
  }

  return null;
};

export const validateTabSchedule = (distribution) => {
  const unixDate = new Date().getTime() / 1000;
  if (distribution.validity_at && distribution.validity_at < unixDate) {
    return {
      field: "validity_at",
      message: i18n.t("distribution.messages.dates_validation"),
      meta: { tab: "schedule" }
    };
  }
  if (distribution.schedule_at && distribution.schedule_at < unixDate) {
    return {
      field: "schedule_at",
      message: i18n.t("distribution.messages.dates_validation"),
      meta: { tab: "schedule" }
    };
  }
  return null;
};

export const validateTabCustomer = (distribution, isDistributed) => {
  if (isDistributed && !distribution.file) {
    return {
      field: "file",
      message: i18n.t("distribution.messages.csv_required"),
      meta: { tab: "customers" }
    };
  }
  return null;
};

export const validateTabChannel = (distribution) => {
  if (!distribution.name) {
    return {
      field: "name",
      message: i18n.t("distribution.messages.name_is_required"),
      meta: { tab: "channel" }
    };
  }
  return null;
};

export const validateCustomerFile = (distribution, identificator) => {
  if (distribution.distribution_channel === DISTRIBUTION_CHANNEL.EMAIL) {
    const mapped = distribution.mapping.find((mapping) => mapping.mapped_to === "email");
    if (mapped === undefined || mapped === null) {
      return i18n.t("distribution.messages.select_column_email");
    }
  }
  if (
    distribution.distribution_channel === DISTRIBUTION_CHANNEL.SMS ||
    distribution.distribution_channel === DISTRIBUTION_CHANNEL.LINKSMS ||
    distribution.distribution_channel === DISTRIBUTION_CHANNEL.WHATSAPP
  ) {
    const mapped = distribution.mapping.find((mapping) => mapping.mapped_to === "phone");
    if (mapped === undefined || mapped === null) {
      return i18n.t("distribution.messages.select_column_phone");
    }
  }
  // The customer need to have identificator of organization
  const mapped = distribution.mapping.find((mapping) => mapping.mapped_to === identificator);
  if (mapped === undefined || mapped === null) {
    return i18n.t("distribution.messages.select_column_identificator");
  }

  return null;
};

export const validateValidityCreatedAt = ({ validityAt, createdAt }) => {
  if (!validityAt || !createdAt) {
    return true;
  }
  return validityAt > createdAt;
};
